module.exports = __webpack_public_path__ + "img/panneau2.58cbbbca.png";